<template>
  <el-dialog :visible="visible" width="50em" @close="close">
    <template slot="title">
      <strong>门诊{{title}}</strong>
    </template>
    <el-container>
      <div v-if="isSettle" style="height: 30px;padding-left: 20px; text-align: left">
        <span style="float: left">收费员：</span>
        <!--<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll">
          全选
        </el-checkbox>-->
        <el-checkbox-group v-model="checkedCashier" @change="queryClosingInfo(true)" style="float: left">
          <el-checkbox v-for="u in cashier" :label="u.id" :key="u.id">
            {{u.realName}}
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <el-header height="40px" v-if="isSettle" style="text-align: left">
        帐期：<el-date-picker
        v-model="timeRange"
        size="mini"
        type="datetimerange"
        range-separator="至"
        :style="{width:'23em'}"
        value-format="yyyy-MM-dd HH:mm:ss"
        :clearable="false"
      >
      </el-date-picker>
        <el-button type="primary" size="mini" @click="queryClosingInfo" style="margin-left: 10px">
          查询
        </el-button>
        <el-button type="primary" size="mini" @click="print">
          打印
        </el-button>
      </el-header>
      <el-header height="30px" v-else style="text-align: left">
        收费员：{{ user.name }}
        <el-button
          type="primary"
          size="mini"
          @click="handleSubmit"
          style="float: right"
          v-show="showSubmit"
        >
          提交
        </el-button>
      </el-header>
      <div v-loading="loading">
        <print-table
          ref="printTable"
          :dataInvoice="dataInvoice"
          :dataByFee="dataByFee"
          :dataByPay="dataByPay"
          :amountObj="amountObj"
          :timeRange="timeRange"
          :feeAmount="feeAmount"
          :issueDate="issueDate"
          :userName="userName"
        />
      </div>
    </el-container>
    <template slot="footer">
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import api from './api';
import commonApi from '@/common/api';
// import print from '@/common/print.js'

const printTable = () => import(/* webpackChunkName: 'printTable' */ './printTable');

export default {
  components: { printTable },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    dateStart: {type: String},
    dateEnd: {type: String}
  },
  data() {
    return {
      timeRange: null,
      issueDate: null,
      dataByFee: [],
      feeAmount: null,
      dataByPay: [],
      payAmount: null,
      dataInvoice: null,
      amountObj: {
        amount: 0, // 应支付总额
        cash: 0, // 实际支付总额
        fund: 0, // 医保支付总额
        discount: 0 // 折扣总额
      },
      cashier: [], // 收费员
      checkedCashier: [],
      loading: false,
      userName: '',
      showSubmit: false
    }
  },
  computed: {
    ...mapGetters(['user', 'dict']),
    amountDiff() {
      return this.$utils.fmtFloat(this.payAmount - this.feeAmount, 2);
    },
    isSettle() {
      return this.title === '结算查询';
    },
  },
  created() {
    this.open();
  },
  methods: {
    async open() {
      this.issueDate = await this.$utils.getServerTime();
      if (this.isSettle) {
        this.getUsers();
        const str = this.issueDate.substring(0, 10);
        this.timeRange = [`${str} 00:00:00`, `${str} 23:59:59`];
      } else {
        this.timeRange = [this.dateStart, this.issueDate];
        this.queryClosingInfo();
      }
    },
    getUsers() {
      commonApi.queryStaff({ ifCashier: true, pageIndexOnView: 1, pageSize: 100, pageIndex: 0 })
        .then(({ items }) => {
          if (Array.isArray(items)) {
            this.cashier = items;
            this.checkedCashier = items.map((i) => i.id);
            this.queryClosingInfo();
          }
        });
    },
    close() {
      this.$emit('update:visible', false);
      this.userName = '';
    },
    // 提交
    handleSubmit() {
      const para = {
        closingStartTime: this.timeRange[0],
        closingEndTime: this.timeRange[1],
        cashierId: this.user.id
      };
      api.execDailySettle(para)
        .then(() => {
          this.$message.success('日结成功');
          this.close();
          this.$emit('refresh');
        })
        .catch(err => this.$message.error(err || '异常'));
    },
    differenceFn(val) {
      if (val === 2) {
        this.dataByPay.push({ type: '货币误差', amount: this.amountDiff });
      }
    },
    queryClosingInfo(isChangeCashier = false) {
      const { checkedCashier } = this;
      if (isChangeCashier && checkedCashier.length === 0) {
        this.$message.warning('请选择收费员');
        return;
      }
      if (!Array.isArray(this.timeRange) || !this.timeRange[0]) {
        this.$message.warning('请选择日期');
        return;
      }
      const cashierId = checkedCashier.length > 0 ? checkedCashier.join(',') : this.user.id;
      if (checkedCashier.length > 0) {
        const names = this.cashier.reduce((a,c) => {
          if (checkedCashier.includes(c.id)){
            a.push(c.realName);
          }
          return a;
        }, []);
        this.userName = names.join('、');
      } else {
        this.userName = this.user.name;
      }
      const queryPara = {
        cashierId,
        closingStartTime: this.timeRange[0],
        closingEndTime: this.timeRange[1]
      };
      this.loading = true;
      // 应收
      let executeFlag = 0;
      api.getCashierFeeType(queryPara).then(res=>{
        this.dataByFee = res.items;
        this.feeAmount = res.items.map(r => r.amount).reduce((p, c) => p + c, 0);
        executeFlag += 1;
        this.differenceFn(executeFlag);
      })
        .catch(err => this.$message.error(err || '异常'));
      // 实收
      api.getCahierPayType(queryPara).then(items => {
        if (items && items.length) {
          items.forEach((i) => {
            const find = this.dict.PayWay.find(p => p.code === i.type);
            // 支付类型对应的名称
            if (find) { i.type = find.name }
            if (i.type === 'med') {
              i.type = '医保';
            }
          });
          this.dataByPay = items;
          this.payAmount = this.$utils.fmtFloat(items.map(r => r.amount).reduce((p, c) => p + c, 0), 2);
          executeFlag += 1;
          this.differenceFn(executeFlag);
          this.loading = false;
        }
      }).catch(err => this.$message.error(err || '异常'));
      // 发票
      api.getCahierInvoices(queryPara).then(res => {
        this.dataInvoice = res;
      }).catch(err => this.$message.error(err || '异常'));

      // 应支付总额、医保支付总额、折扣总额、实际支付总额
      api.getAccount(queryPara)
        .then(res => {
          if (res) {
            this.amountObj = {
              amount: res.amount || 0, // 应支付总额
              cash: res.cash || 0, // 实际支付总额
              fund: res.fund || 0, // 医保支付总额
              discount: res.discount || 0 // 折扣总额
            };
            if (res.amount) this.showSubmit = true;
          }
          if (!res.amount && !this.isSettle) {
            this.showSubmit = false;
            this.$message('当前暂无日结数据');
          }
        })
        .catch(err => this.$message.error(err || '异常'));
    },
    convToCols(data, cnt) {
      let records = [];
      if (data && data.length > 0) {
        let row = {};
        data.forEach((r, i) => {
          let suffix = i % cnt;
          Object.entries(r).forEach(([k, v]) => {
            row[k + '-' + suffix] = v;
          });
          if(suffix === (cnt - 1)) {
            if(row) records.push(row);
            row = {};
          }
        });
        if(Object.entries(row).length > 0) {
          records.push(row);
        }
      }
      return records;
    },
    print() {
      if (this.$refs.printTable) {
        this.$refs.printTable.printFn();
      }
    }
  }
};
</script>
